import { useMemo } from 'react';
import { useValueVsAmountInvestedQuery } from '../api/useValueVsAmountInvestedQuery';
import { usePeriod } from './usePeriod';
import { useRouteParams } from './useRouteParams';

export const useAmountInvestedChart = () => {
  const period = usePeriod();

  const { accountId, clientId, groupId } = useRouteParams();

  const queryInfo = useValueVsAmountInvestedQuery({
    clientId,
    period: period.value,
    startDate: period.dates[0],
    endDate: period.dates[1],
    accountId,
    groupId,
  });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const hasData = Object.values(queryInfo.data).some(
      ({ data: seriesData }) => seriesData.length > 0,
    );

    return hasData
      ? Object.values(queryInfo.data).map(({ name, data: seriesData }) => ({
          name,
          data: seriesData.map(({ date, value }) => {
            const parsedDate = new Date(date);
            const timeStampDate = parsedDate.getTime();
            return [timeStampDate, value];
          }),
        }))
      : [];
  }, [queryInfo.data]);

  return { ...queryInfo, data };
};
